// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/supply_demand_gap_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { GapAreaSeries, GapRangeType, GapRepresentativeValue, ProcurementNeedAreaSeries, ProcurementNeedMarket } from "./supply_demand_gap_model_pb";
import { file_bffuser_v1_supply_demand_gap_model } from "./supply_demand_gap_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/supply_demand_gap_service.proto.
 */
export const file_bffuser_v1_supply_demand_gap_service: GenFile = /*@__PURE__*/
  fileDesc("CipiZmZ1c2VyL3YxL3N1cHBseV9kZW1hbmRfZ2FwX3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiwQIKGUdldFN1cHBseURlbWFuZEdhcFJlcXVlc3QSOAoKcmFuZ2VfdHlwZRgBIAEoDjIYLmJmZnVzZXIudjEuR2FwUmFuZ2VUeXBlQgq6SAeCAQQQASAAEi4KC3BlcmlvZF9mcm9tGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEiwKCXBlcmlvZF90bxgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBARJACgphcmVhX2NvZGVzGAQgAygOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCFbpIEpIBDwgBEAoYASIHggEEEAEgABJKChRyZXByZXNlbnRhdGl2ZV92YWx1ZRgFIAEoDjIiLmJmZnVzZXIudjEuR2FwUmVwcmVzZW50YXRpdmVWYWx1ZUIIukgFggECEAEiTAoaR2V0U3VwcGx5RGVtYW5kR2FwUmVzcG9uc2USLgoLYXJlYV9zZXJpZXMYASADKAsyGS5iZmZ1c2VyLnYxLkdhcEFyZWFTZXJpZXMijQIKGUdldFByb2N1cmVtZW50TmVlZFJlcXVlc3QSJwoEZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBARI6CgphcmVhX2NvZGVzGAIgAygOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCD7pIDJIBCSIHggEEEAEgABI9CgZtYXJrZXQYAyABKA4yIS5iZmZ1c2VyLnYxLlByb2N1cmVtZW50TmVlZE1hcmtldEIKukgHggEEEAEgABI8Cgtpc3N1ZXJfdHlwZRgEIAEoDjIYLmJmZnR5cGVzLnYxLkxpY2Vuc2VUeXBlQgi6SAWCAQIQAUgAiAEBQg4KDF9pc3N1ZXJfdHlwZSJYChpHZXRQcm9jdXJlbWVudE5lZWRSZXNwb25zZRI6CgthcmVhX3NlcmllcxgBIAMoCzIlLmJmZnVzZXIudjEuUHJvY3VyZW1lbnROZWVkQXJlYVNlcmllczLiAQoWU3VwcGx5RGVtYW5kR2FwU2VydmljZRJjChJHZXRTdXBwbHlEZW1hbmRHYXASJS5iZmZ1c2VyLnYxLkdldFN1cHBseURlbWFuZEdhcFJlcXVlc3QaJi5iZmZ1c2VyLnYxLkdldFN1cHBseURlbWFuZEdhcFJlc3BvbnNlEmMKEkdldFByb2N1cmVtZW50TmVlZBIlLmJmZnVzZXIudjEuR2V0UHJvY3VyZW1lbnROZWVkUmVxdWVzdBomLmJmZnVzZXIudjEuR2V0UHJvY3VyZW1lbnROZWVkUmVzcG9uc2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bffuser_v1_supply_demand_gap_model, file_buf_validate_validate, file_google_type_date]);

/**
 * @generated from message bffuser.v1.GetSupplyDemandGapRequest
 */
export type GetSupplyDemandGapRequest = Message<"bffuser.v1.GetSupplyDemandGapRequest"> & {
  /**
   * 集計範囲種別。DAY=48コマ / MONTH=日次 / YEAR=日次。
   *
   * @generated from field: bffuser.v1.GapRangeType range_type = 1;
   */
  rangeType: GapRangeType;

  /**
   * 集計期間の開始日 (上位で解決済みの実日付)。
   *
   * @generated from field: google.type.Date period_from = 2;
   */
  periodFrom?: Date;

  /**
   * 集計期間の終了日。
   *
   * @generated from field: google.type.Date period_to = 3;
   */
  periodTo?: Date;

  /**
   * 対象エリアコード一覧。
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 4;
   */
  areaCodes: AreaCode[];

  /**
   * 代表値種別 (DAY range では無視)。
   *
   * @generated from field: bffuser.v1.GapRepresentativeValue representative_value = 5;
   */
  representativeValue: GapRepresentativeValue;
};

/**
 * Describes the message bffuser.v1.GetSupplyDemandGapRequest.
 * Use `create(GetSupplyDemandGapRequestSchema)` to create a new message.
 */
export const GetSupplyDemandGapRequestSchema: GenMessage<GetSupplyDemandGapRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_service, 0);

/**
 * @generated from message bffuser.v1.GetSupplyDemandGapResponse
 */
export type GetSupplyDemandGapResponse = Message<"bffuser.v1.GetSupplyDemandGapResponse"> & {
  /**
   * エリアごとの集計系列。
   *
   * @generated from field: repeated bffuser.v1.GapAreaSeries area_series = 1;
   */
  areaSeries: GapAreaSeries[];
};

/**
 * Describes the message bffuser.v1.GetSupplyDemandGapResponse.
 * Use `create(GetSupplyDemandGapResponseSchema)` to create a new message.
 */
export const GetSupplyDemandGapResponseSchema: GenMessage<GetSupplyDemandGapResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_service, 1);

/**
 * @generated from message bffuser.v1.GetProcurementNeedRequest
 */
export type GetProcurementNeedRequest = Message<"bffuser.v1.GetProcurementNeedRequest"> & {
  /**
   * 受渡日 (上位で解決済みの実日付)。
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * 対象エリアコード一覧。1 件以上 (空は BFF → backend で InvalidArgument)。
   *
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 2;
   */
  areaCodes: AreaCode[];

  /**
   * 算出対象市場 (SPOT / INTRADAY)。
   *
   * @generated from field: bffuser.v1.ProcurementNeedMarket market = 3;
   */
  market: ProcurementNeedMarket;

  /**
   * 発注主体区分 (需要BG / 発電 / 自己託送BG)。省略時はエリア全体 (区分なし)。
   * 指定時は market = SPOT のみ受け付け、区分が受渡契約コードを解決できないエリア
   * (発電は発電販売計画が無いエリアも) の series は返さない。
   * 番号が internalapi (5) と違うのは、BFF 版が organization_id を持たず既存 field が 1 つずつずれているため。
   *
   * @generated from field: optional bfftypes.v1.LicenseType issuer_type = 4;
   */
  issuerType?: LicenseType;
};

/**
 * Describes the message bffuser.v1.GetProcurementNeedRequest.
 * Use `create(GetProcurementNeedRequestSchema)` to create a new message.
 */
export const GetProcurementNeedRequestSchema: GenMessage<GetProcurementNeedRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_service, 2);

/**
 * @generated from message bffuser.v1.GetProcurementNeedResponse
 */
export type GetProcurementNeedResponse = Message<"bffuser.v1.GetProcurementNeedResponse"> & {
  /**
   * エリアごとの 48 コマ調達必要量系列。
   *
   * @generated from field: repeated bffuser.v1.ProcurementNeedAreaSeries area_series = 1;
   */
  areaSeries: ProcurementNeedAreaSeries[];
};

/**
 * Describes the message bffuser.v1.GetProcurementNeedResponse.
 * Use `create(GetProcurementNeedResponseSchema)` to create a new message.
 */
export const GetProcurementNeedResponseSchema: GenMessage<GetProcurementNeedResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_demand_gap_service, 3);

/**
 * @generated from service bffuser.v1.SupplyDemandGapService
 */
export const SupplyDemandGapService: GenService<{
  /**
   * GetSupplyDemandGap returns aggregated supply/demand gap series per area.
   *
   * @generated from rpc bffuser.v1.SupplyDemandGapService.GetSupplyDemandGap
   */
  getSupplyDemandGap: {
    methodKind: "unary";
    input: typeof GetSupplyDemandGapRequestSchema;
    output: typeof GetSupplyDemandGapResponseSchema;
  },
  /**
   * GetProcurementNeed returns per-area 48-koma procurement need (調達必要量)
   * for the bidding position chart.
   *
   * @generated from rpc bffuser.v1.SupplyDemandGapService.GetProcurementNeed
   */
  getProcurementNeed: {
    methodKind: "unary";
    input: typeof GetProcurementNeedRequestSchema;
    output: typeof GetProcurementNeedResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_supply_demand_gap_service, 0);

